module.exports = __webpack_public_path__ + "static/media/travel.dae9c0ba.jpeg";